// Event text is stored per language in suffixed columns: name (English),
// name_de, name_es, name_zh. Everything reads fields through this helper, so
// adding a language is a new column plus a line in LOCALE_SUFFIX.
const LOCALE_SUFFIX = {
  en: '',
  de: '_de',
  fr: '_fr',
  es: '_es',
  it: '_it',
  ru: '_ru',
  zh: '_zh',
};

export const LOCALES = Object.keys(LOCALE_SUFFIX);

/**
 * localized(event, 'name', 'es') -> event.name_es, falling back to English
 * when that translation is missing or empty.
 */
export const localized = (record, field, locale) => {
  if (!record) {
    return '';
  }

  const suffix = LOCALE_SUFFIX[locale];
  const translated = suffix ? record[`${field}${suffix}`] : null;

  return translated || record[field] || '';
};
